export const useScrollIntoView = () => {
  const scrollTo = ({
    top = 0,
    left = 0,
    horizontal,
    averageWidth = 0,
    scrollableContainer,
    errorCallback,
  }) => {
    const isScrollingElement =
      (scrollableContainer?.clientWidth ?? 0) <
      (scrollableContainer?.scrollWidth ?? 0);

    if (
      !scrollableContainer ||
      typeof scrollableContainer?.scrollTo !== "function" ||
      !isScrollingElement
    ) {
      return errorCallback();
    }

    scrollableContainer?.scrollTo({
      top: top,
      left: left,
      behaviour: "smooth",
    });

    return new Promise((resolve) => {
      const _totalScrollHorizontal = scrollableContainer?.scrollLeft + left;

      if (
        _totalScrollHorizontal >
          scrollableContainer?.scrollWidth - averageWidth ||
        left <= 0
      ) {
        return resolve();
      }

      const scrollHandler = () => {
        if (horizontal) {
          if (scrollableContainer?.scrollLeft === left) {
            scrollableContainer?.removeEventListener("scroll", scrollHandler);

            resolve();
          }
        }

        if (scrollableContainer?.scrollTop === top) {
          scrollableContainer?.removeEventListener("scroll", scrollHandler);

          resolve();
        }
      };
      scrollableContainer?.addEventListener("scroll", scrollHandler);

      resolve();
    });
  };
  return {
    scrollTo,
  };
};
